import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/fermentations/$group_id/planning/")({
  component: PlanningIndex,
});

function PlanningIndex() {
  const { group_id } = Route.useParams();
  return <Navigate to="/fermentations/$group_id/planning/general" params={{ group_id }} replace />;
}
